import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, Monitor } from 'lucide-react';
import { Button } from './ui/button';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  const isActive = (path) => location.pathname === path;

  return (
    <header className="sticky top-0 z-50 w-full border-b bg-white/95 backdrop-blur supports-[backdrop-filter]:bg-white/80">
      <nav className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex h-16 items-center justify-between">
          <Link to="/" className="flex items-center space-x-2">
            <Monitor className="h-8 w-8 text-blue-600" />
            <div className="flex flex-col">
              <span className="text-xl font-bold text-gray-900">Microworld Solution</span>
              <span className="text-xs text-gray-600">Inc.</span>
            </div>
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden md:flex md:items-center md:space-x-6">
            <Link
              to="/"
              className={`text-sm font-medium transition-colors hover:text-blue-600 ${
                isActive('/') ? 'text-blue-600' : 'text-gray-700'
              }`}
            >
              Home
            </Link>
            <Link
              to="/#support"
              className="text-sm font-medium text-gray-700 transition-colors hover:text-blue-600"
            >
              Support Services
            </Link>
            <Link
              to="/#pricing"
              className="text-sm font-medium text-gray-700 transition-colors hover:text-blue-600"
            >
              Pricing
            </Link>
            <Link
              to="/shop"
              className={`text-sm font-medium transition-colors hover:text-blue-600 ${
                isActive('/shop') ? 'text-blue-600' : 'text-gray-700'
              }`}
            >
              Shop Computers
            </Link>
            <Link
              to="/antivirus"
              className={`text-sm font-medium transition-colors hover:text-blue-600 ${
                isActive('/antivirus') ? 'text-blue-600' : 'text-gray-700'
              }`}
            >
              Antivirus Software
            </Link>
            <Link
              to="/sonicwall"
              className={`text-sm font-medium transition-colors hover:text-blue-600 ${
                isActive('/sonicwall') ? 'text-blue-600' : 'text-gray-700'
              }`}
            >
              SonicWall Firewalls
            </Link>
            <Button asChild size="sm" className="ml-4">
              <Link to="/#contact">Get Support</Link>
            </Button>
          </div>

          {/* Mobile menu button */}
          <button
            className="md:hidden rounded-md p-2 text-gray-700 hover:bg-gray-100 hover:text-gray-900"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            {isMenuOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <div className="md:hidden py-4 space-y-2">
            <Link
              to="/"
              className="block px-3 py-2 rounded-md text-base font-medium text-gray-700 hover:bg-gray-100 hover:text-blue-600"
              onClick={() => setIsMenuOpen(false)}
            >
              Home
            </Link>
            <Link
              to="/#support"
              className="block px-3 py-2 rounded-md text-base font-medium text-gray-700 hover:bg-gray-100 hover:text-blue-600"
              onClick={() => setIsMenuOpen(false)}
            >
              Support Services
            </Link>
            <Link
              to="/#pricing"
              className="block px-3 py-2 rounded-md text-base font-medium text-gray-700 hover:bg-gray-100 hover:text-blue-600"
              onClick={() => setIsMenuOpen(false)}
            >
              Pricing
            </Link>
            <Link
              to="/shop"
              className="block px-3 py-2 rounded-md text-base font-medium text-gray-700 hover:bg-gray-100 hover:text-blue-600"
              onClick={() => setIsMenuOpen(false)}
            >
              Shop Computers
            </Link>
            <Link
              to="/antivirus"
              className="block px-3 py-2 rounded-md text-base font-medium text-gray-700 hover:bg-gray-100 hover:text-blue-600"
              onClick={() => setIsMenuOpen(false)}
            >
              Antivirus Software
            </Link>
            <Link
              to="/sonicwall"
              className="block px-3 py-2 rounded-md text-base font-medium text-gray-700 hover:bg-gray-100 hover:text-blue-600"
              onClick={() => setIsMenuOpen(false)}
            >
              SonicWall Firewalls
            </Link>
            <Button asChild className="w-full mt-2">
              <Link to="/#contact" onClick={() => setIsMenuOpen(false)}>Get Support</Link>
            </Button>
          </div>
        )}
      </nav>
    </header>
  );
};

export default Header;